import axios from 'axios'
import library from '../../../utils/Library'

export const helpGetFileExtends = async () => {
  const TOKEN = sessionStorage.getItem('token')
  const URL = library.getBaseAPIUrl('fileExtend') + '/all'
  return axios.get(URL, {
    headers: {
      Authorization: `Bearer ${TOKEN}`
    }
  })
}
